import socketIO, { ManagerOptions, Socket, SocketOptions } from 'socket.io-client';
import { finalUrlsConfig } from 'src/configs/url.config';

let socket: Socket | undefined;

// Create socket connection function
export const createConnection = (options?: Partial<ManagerOptions & SocketOptions>) => {
  socket = socketIO(finalUrlsConfig().socketURL, {
    transports: ['websocket', 'polling'],
    upgrade: true,
    path: '/socket',
    ...options,
  });
};

export const listenSocket = (id: string, callback: (data: any) => void) => {
  socket?.on(id, callback);
};

export const closeSocket = () => {
  socket?.close();
};
